import * as React from 'react';
import * as styles from './header.scss';
import * as colStyles from 'components/grid/col.scss';

import SVGLogo from 'components/svg/Logo';
import SVGLogoWithText from 'components/svg/LogoWithText';
import {Grid, Col} from '../grid';

const Header: React.StatelessComponent<{}> = () => {
        return (

            <header className={styles.header}>
                <Grid className={styles.grid}>

                    <Col
                        className={colStyles.col4 + ' ' + colStyles.col4Md + ' ' + colStyles.col4Dt}
                    >
                        <div className={styles.logoLink}>
                            <SVGLogo className={styles.logoIcon} title={'home'}/>
                            <SVGLogoWithText className={styles.logoIconWithText} title={'home'}/>
                            <span className={styles.logoText}>
                                <span className={styles.logoText2}>Authentifizierung</span>
                            </span>
                        </div>
                    </Col>
                </Grid>
            </header>

        )
}
export default Header;